import React from "react";

export default function Clipboard(props: React.ComponentProps<"svg">) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="33"
            viewBox="0 0 28 33"
        >
            <g fill="none" fillRule="evenodd">
                <g stroke="currentColor" strokeWidth="1.6">
                    <g>
                        <g>
                            <g transform="translate(-600 -1132) translate(232 1122) translate(289) translate(80 11)">
                                <rect width="18" height="23" x="8" y="8" rx="4" />
                                <path
                                    d="M13.954 0h.896C16.59 0 18 1.41 18 3.15V19c0 2.21-1.79 4-4 4H3.676C1.646 23 0 21.354 0 19.324h0"
                                    transform="rotate(-180 9 11.5)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
